import '@/app/app.css';
import './about.css';

import '@/app/app';
import '@/layouts/main/main.js';
import { initSectionAdvantages } from '@/widgets/section/section-advantages/section-advantages';

window.addEventListener('DOMContentLoaded', () => {
	initSectionAdvantages();
});
